import { type FocusEvent, type KeyboardEvent, type MouseEvent, useRef } from 'react';
import classNames from 'classnames';

export interface LinkButtonTextFieldProps {
    id: string;
    label: string;
    type?: string;
    value: string;
    metric?: string;
    prefix?: string;
    showInput: boolean;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    onTextChange?: (value: string) => void;
    onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
    onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
    onKeyPress?: (event: KeyboardEvent) => void;
    floatRight?: boolean;
    min?: number;
    max?: number;
}
export const LinkButtonTextField = ({
    id,
    label,
    type,
    value,
    metric = '',
    prefix = '',
    showInput,
    onClick,
    onTextChange,
    onBlur,
    onFocus,
    onKeyPress,
    floatRight,
}: LinkButtonTextFieldProps) => {
    const shouldFocus = useRef(false);

    const focusIfClicked = (element: HTMLInputElement): void => {
        if (shouldFocus.current) {
            element.focus();
            shouldFocus.current = false;
        }
    };

    return (
        (showInput && (
            <div className="input input--no-bottom-margin input--number">
                <label className="label" htmlFor={id}>
                    {label}
                </label>
                <input
                    id={id}
                    type={type}
                    data-testid={`LinkButtonTextField-input-${id}`}
                    value={value}
                    onChange={(event) => {
                        onTextChange(event.target.value);
                    }}
                    onFocus={(event: FocusEvent<HTMLInputElement>): void => {
                        if (onFocus) {
                            onFocus(event);
                        }
                        event.target.select();
                    }}
                    onBlur={onBlur}
                    onKeyPress={onKeyPress}
                    ref={focusIfClicked}
                />
            </div>
        )) || (
            <button
                type="button"
                className={classNames('button button--link', { 'u-float-right': floatRight })}
                data-testid={`LinkButtonTextField-button-${id}`}
                onClick={(event: MouseEvent<HTMLButtonElement>): void => {
                    if (onClick) onClick(event);
                    shouldFocus.current = true;
                }}>
                {prefix} {value} {metric}
            </button>
        )
    );
};
